import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem, metrics } from '../../__styling'

// TheNightly Colors
const tnColors = tokens.thenightly.colors
const tnPalette = tnColors.palette
// TheNightly Metrics
const tnMetrics = metrics.thenightly.margins

// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette
// PerthNow Metrics
const pnMetrics = metrics.perthnow.margins

interface StyledOptionItemProps {
    disabled?: boolean
    editable?: boolean
}

export const StyledHint = styled('small')(({ theme }) => [
    theme.kind === 'perthnow' && {
        paddingTop: calcRem(8),
        fontSize: calcRem(14) + ' !important',
    },
])

export const StyledOptionItem = styled('li')<StyledOptionItemProps>(
    ({ disabled, editable = true, theme }) => [
        {
            padding: calcRem(tnMetrics.md, 0),
            borderBottom: `0.5px solid ${tnPalette.neutral[20]}`,
            cursor: disabled ? 'not-allowed' : editable ? 'pointer' : 'default',
            '& > div': {
                display: 'flex',
                div: {
                    flex: 1,
                },
            },

            div: {
                '&:value-wrapper': {
                    paddingRight: calcRem(8),
                },
            },

            small: {
                fontSize: calcRem(12),
                fontWeight: 400,
                lineHeight: calcRem(16),
                color: tnPalette.neutral[70],
            },

            p: {
                margin: 0,
                fontWeight: 400,
                color: tnPalette.neutral[100],
                lineHeight: '150%',

                wordBreak: 'break-word',
            },

            span: {
                display: 'flex',
                alignItems: 'center',
                color: disabled
                    ? tnPalette.neutral[30]
                    : tnPalette.uplate.default,
                svg: {
                    marginLeft: calcRem(5),
                },
            },

            a: {
                color: tnPalette.section.opinion[30],
            },
        },
        // PerthNow Styling
        theme.kind === 'perthnow' && {
            padding: calcRem(20, 0),
            borderBottom: `1px solid ${pnPalette.blackShade[14]}`,

            '&:last-child': {
                borderBottom: 'none',
            },

            small: {
                fontFamily: theme.fonts.sansSerif,
                color: pnPalette.greyWeak,

                display: 'block',
                height: 'fit-content',
            },
            p: {
                fontFamily: theme.fonts.sansSerif,
                color: pnPalette.blackShade[85],
                fontSize: calcRem(16),
                lineHeight: calcRem(16),

                display: 'block',
                height: 'fit-content',
            },

            a: {
                color: pnPalette.blackShade[85],
            },

            div: {
                '&:value-wrapper': {
                    height: 'fit-content',
                },
            },

            span: {
                fontFamily: theme.fonts.sansSerif,
                fontSize: calcRem(14),
                fontWeight: 400,
                lineHeight: calcRem(16),
                color: disabled ? pnPalette.blackShade[10] : pnPalette.greyCoal,

                // Chevron colouring
                svg: {
                    marginLeft: 0,

                    path: {
                        stroke: disabled
                            ? pnPalette.blackShade[10]
                            : pnPalette.greyWeak,
                    },
                },
            },
        },
    ],
)

export const StyledManageAccount = styled('div')(({ theme }) => [
    {
        ul: {
            listStyle: 'none',
            padding: 0,
            margin: calcRem(0, 0, tnMetrics.lg, 0),
        },
    },
    // PerthNow Styling
    theme.kind === 'perthnow' && {
        ul: {
            margin: 0,
        },
    },
])
